import { computed, type Ref, type WritableComputedRef } from 'vue'
import { mapValues } from 'remeda'
import type { NonNullableKeys } from '@/types/utils'
import type { DiamondSearchFilters } from '@/domain/stone/diamond'
import type { NonSkuGemstoneFilters } from '@/graphql/api'

export function useFilterBindings<T extends DiamondSearchFilters>(
    values: Readonly<Ref<T>>,
    defaults: NonNullableKeys<T>,
    emit: (event: 'update:values', v: T) => void
): {
    [K in keyof T]: WritableComputedRef<NonNullable<T[K]>, NonNullable<T[K]>>
} {
    return mapValues(values.value, (_value, key) =>
        computed({
            // @ts-expect-error alabala
            get: () => values.value[key as keyof T] || defaults[key],
            set: (v) => emit('update:values', { ...values.value, [key]: v }),
        })
    ) as {
        [K in keyof T]: WritableComputedRef<NonNullable<T[K]>>
    }
}

export function useNonSkuGemstoneFilterBindings<
    T extends NonSkuGemstoneFilters,
>(
    values: Readonly<Ref<T>>,
    defaults: NonNullableKeys<T>,
    emit: (event: 'update:values', v: T) => void
): {
    [K in keyof T]: WritableComputedRef<NonNullable<T[K]>, NonNullable<T[K]>>
} {
    return mapValues(values.value, (_value, key) =>
        computed({
            // @ts-expect-error alabala
            get: () => values.value[key as keyof T] || defaults[key],
            set: (v) => emit('update:values', { ...values.value, [key]: v }),
        })
    ) as {
        [K in keyof T]: WritableComputedRef<NonNullable<T[K]>>
    }
}
